import { Error404 } from '@/components/Error';

export default function Error404Page() {
  return <Error404 />;
}
